import React from "react";
import { observer } from "mobx-react";
import {
  BrowserRouter as Router,
  RouteComponentProps,
  Switch,
  Route,
} from "react-router-dom";
import IndexLead from "./IndexLead";

interface LeadProps extends RouteComponentProps {
  changeToggle(action?: boolean): void;
}

@observer
export default class Lead extends React.Component<LeadProps> {
  render() {
    return (
      <Router>
        <Switch>
          <Route
            exact
            path="/leads"
            render={(props) => (
              <IndexLead {...props} changeToggle={this.props.changeToggle} />
            )}
          ></Route>
        </Switch>
      </Router>
    );
  }
}
